'use client'

import Image from 'next/image'
import Link from 'next/link'
import { memo } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'
import { getBotInfo } from '@/shared/lib/seo'
import { ElementsSliderFree } from '@/shared/ui/elements-slider-free'

import { Brand, BrandsListProps } from '../../types/brand'

import cl from './BrandsList.module.scss'

/**
 * BrandsList component displays a carousel of brand logos
 * with links to their respective brand pages
 */
export const BrandsList = memo((props: BrandsListProps) => {
	const { brands = [], getBrandUrl = (code: string) => `/brand/${code}` } = props

	// Filter out brands without images
	const filteredBrands = brands.filter(brand => !!brand.IMAGE)

	return (
		<div className={cl.root}>
			<div className={cl.content}>
				<ElementsSliderFree classNameRoot={cl.elementsSlider} classNameSlide={cl.slide}>
					{filteredBrands.map(brand => (
						<BrandItem key={brand.NAME} brand={brand} getBrandUrl={getBrandUrl} />
					))}
				</ElementsSliderFree>
			</div>
		</div>
	)
})

BrandsList.displayName = 'BrandsList'

interface BrandItemProps {
	brand: Brand
	getBrandUrl: (code: string) => string
}

const BrandItem = memo((props: BrandItemProps) => {
	const { brand, getBrandUrl } = props
	const { NAME, CODE, IMAGE } = brand

	const isBot = getBotInfo('isDetected')

	return (
		<Link href={getBrandUrl(CODE)} prefetch={false}>
			<article className={cl.article}>
				<div className={cl.article__image}>
					<Image src={`${BASE_URL}${IMAGE}`} priority={isBot} width={200} height={120} alt={NAME} draggable={false} />
				</div>
			</article>
		</Link>
	)
})

BrandItem.displayName = 'BrandItem'
